import React from 'react';
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import Menu from 'material-ui/svg-icons/navigation/menu';
import * as colors from 'material-ui/styles/colors';
import Avatar from 'material-ui/Avatar';
import SearchIcon from 'material-ui/svg-icons/action/perm-identity';

class Header extends React.Component {

  render() {
    const {styles, handleChangeRequestNavDrawer, handleLogout, auth} = this.props;

    const style = {
      appBar: {
        position: 'fixed',
        top: 0,
        overflow: 'hidden',
        maxHeight: 57
      },
      menuButton: {
        marginLeft: 10
      },
      iconsRightContainer: {
        marginLeft: 20
      }
    };

    return (
        <div>
            <AppBar
              title='INS統合管理システム'
              style={{...styles, ...style.appBar}}
              titleStyle={{fontSize: 17}}
              iconElementLeft={
                  <IconButton style={style.menuButton} onClick={handleChangeRequestNavDrawer}>
                    <Menu color={colors.white} />
                  </IconButton>
              }
              iconElementRight={

                  <div style={{display: 'flex', alignItems: 'center' }}>
                      <div>
                        <span style={{marginRight: 10, color: colors.white, fontSize: 12}}>Ver: 1.11.2</span>
                      </div>
                      <div>
                          <Avatar
                              icon={<SearchIcon color={colors.white} />}
                              color={colors.white}
                              backgroundColor={process.env.REACT_APP_MODE == "dev" ? colors.pink800 : colors.blue800}
                              size={30}
                              style={{margin: 5}}
                          />
                      </div>
                      <div>
                          <span style={{marginLeft: 5, color: colors.white, fontSize: 16}}>{auth.user.name}</span>
                      </div>
                      <div style={style.iconsRightContainer}>
                          <IconMenu color={colors.white}
                                    iconButtonElement={
                                        <IconButton><MoreVertIcon color={colors.white}/></IconButton>
                                    }
                                    targetOrigin={{horizontal: 'right', vertical: 'top'}}
                                    anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                          >
                              <MenuItem primaryText="ログアウト" onTouchTap={handleLogout}/>
                          </IconMenu>
                      </div>
                  </div>
              }
            />
          </div>
      );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js